<template>
  <div class="register-info-box">
    <div class="login-title">
      <span class="login-title-wel">欢迎注册</span>
      <span class="login-title-tex">国产自主三维图形引擎</span>
    </div>
    <div class="login-register">
      <span class="login-register-not">已有账号?</span>
      <span
        class="login-register-addRegiser"
        @click="switchPanel('login')"
        >返回登录</span
      >
    </div>
    <div class="form-box public-form-primary">
      <el-form
        ref="form"
        :model="form"
        :rules="rules"
        label-width="96px">
        <div class="form-item-box">
          <el-form-item
            label="用户名："
            prop="userName">
            <div class="custom-input-box">
              <el-input
                class="input-primary"
                size="small"
                placeholder="请输入用户名"
                v-model="form.userName" />
            </div>
          </el-form-item>
        </div>
        <div class="form-item-box">
          <el-form-item
            label="密码："
            prop="password">
            <div class="custom-input-box">
              <el-input
                class="input-primary"
                size="small"
                show-password
                placeholder="请输入密码"
                v-model="form.password" />
            </div>
          </el-form-item>
        </div>
        <div class="form-item-box">
          <el-form-item
            label="确认密码："
            prop="confirmPassword">
            <div class="custom-input-box">
              <el-input
                class="input-primary"
                size="small"
                show-password
                placeholder="请再次输入密码"
                v-model="form.confirmPassword" />
            </div>
          </el-form-item>
        </div>
        <div class="form-item-box">
          <el-form-item
            label="姓名："
            prop="name">
            <div class="custom-input-box">
              <el-input
                class="input-primary"
                size="small"
                placeholder="请输入您的姓名"
                v-model="form.name" />
            </div>
          </el-form-item>
        </div>
        <div class="form-item-box">
          <el-form-item
            label="邮箱："
            prop="email">
            <div class="custom-input-box">
              <el-input
                class="input-primary"
                size="small"
                placeholder="请输入您的邮箱"
                v-model="form.email" />
            </div>
          </el-form-item>
        </div>
        <div class="form-item-box">
          <el-form-item
            label="公司名称："
            prop="company">
            <div class="custom-input-box">
              <el-input
                class="input-primary"
                size="small"
                placeholder="请输入您的公司名称"
                v-model="form.company" />
            </div>
          </el-form-item>
        </div>
        <div class="special-form-item-box">
          <el-form-item
            label="企业类型："
            prop="enterpriseType"
            class="select-item-box"
            ref="enterPriseTypeForm">
            <div class="custom-select-box">
              <el-select
                class="primary-select"
                size="small"
                v-model="form.enterpriseType"
                placeholder="请选择您的企业类型"
                :popper-append-to-body="false">
                <el-option
                  v-for="(item, index) in enterpriseTypeList"
                  :key="index"
                  :label="item"
                  :value="item" />
                <el-option value="其他">
                  <div @click="clearValidMsg('enterPriseTypeForm')">其他</div>
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            prop="enterpriseTypeInput"
            v-if="form.enterpriseType === '其他'"
            ref="enterPriseTypeInputForm">
            <div class="custom-input-box">
              <el-input
                class="input-primary"
                size="small"
                placeholder="请输入企业类型"
                @blur="inputBlur()"
                v-model="form.enterpriseTypeInput" />
            </div>
          </el-form-item>
        </div>
        <div class="special-form-item-box">
          <el-form-item
            label="所在省份："
            prop="province"
            class="select-item-box">
            <div class="custom-select-box">
              <el-select
                class="primary-select"
                size="small"
                filterable
                v-model="form.province"
                popper-class="primary-select-outer"
                placeholder="请选择您的所在省份"
                :popper-append-to-body="true">
                <el-option
                  v-for="(item, index) in provinceList"
                  :key="index"
                  :label="item"
                  :value="item" />
              </el-select>
            </div>
          </el-form-item>
        </div>
        <div class="special-form-item-box">
          <el-form-item
            label="岗位："
            prop="position"
            class="select-item-box"
            ref="positionForm">
            <div class="custom-select-box">
              <el-select
                class="primary-select"
                size="small"
                v-model="form.position"
                placeholder="请选择您的岗位"
                 popper-class="primary-select-outer"
                :popper-append-to-body="true">
                <el-option
                  v-for="(item, index) in positionList"
                  :key="index"
                  :label="item"
                  :value="item" />
                <el-option value="其他">
                  <div @click="clearValidMsg('positionForm')">其他</div>
                </el-option>
              </el-select>
            </div>
          </el-form-item>
          <el-form-item
            prop="positionInput"
            v-if="form.position === '其他'"
            ref="positionInputForm">
            <div class="custom-input-box">
              <el-input
                class="input-primary"
                size="small"
                @blur="inputBlur()"
                placeholder="请输入您的岗位"
                v-model="form.positionInput" />
            </div>
          </el-form-item>
        </div>
      </el-form>
    </div>
    <div class="common-button-box">
      <el-button
        class="submit-btn primary-btn primary-angb-btn"
        type="primary"
        @click="registerUser">
        注册
      </el-button>
    </div>
  </div>
</template>

<script>
import { encryptPassword } from '@/utils/generalMethods'
import {
  userNameRules,
  passwordRules,
  nameRules,
  emailRules,
  companyRules,
  enterpriseTypeRules,
  enterpriseTypeInputRules,
  positionRules,
  positionInputRules
} from '@/utils/formValidateRules'
export default {
  data() {
    const validConfirmPassword = (rule, value, callback) => {
      if (value === this.form.password) {
        callback()
      } else {
        return callback(new Error('两次输入密码不一致'))
      }
    }
    const validEnterpriseTypeInput = (rule, value, callback) => {
      if (enterpriseTypeInputRules.pattern.test(value)) {
        callback()
      } else {
        return callback(new Error(enterpriseTypeInputRules.message))
      }
    }
    const validPositionInput = (rule, value, callback) => {
      if (positionInputRules.pattern.test(value)) {
        callback()
      } else {
        return callback(new Error(positionInputRules.message))
      }
    }
    return {
      enterpriseTypeList: [
        '施工单位',
        '设计单位',
        '建设方',
        '科技公司',
        '高校'
      ],
      positionList: ['软件开发', '建模设计', '工程管理'],
      provinceList: [
        '北京市',
        '上海市',
        '天津市',
        '重庆市',
        '湖北省',
        '湖南省',
        '广东省',
        '河南省',
        '河北省',
        '山东省',
        '山西省',
        '江苏省',
        '江西省',
        '浙江省',
        '黑龙江省',
        '辽宁省',
        '吉林省',
        '甘肃省',
        '青海省',
        '陕西省',
        '海南省',
        '福建省',
        '安徽省',
        '云南省',
        '贵州省',
        '四川省',
        '广西壮族自治区',
        '宁夏回族自治区',
        '内蒙古自治区',
        '西藏自治区',
        '新疆维吾尔自治区',
        '台湾省',
        '香港特别行政区',
        '澳门特别行政区'
      ],
      form: {
        userName: '',
        password: '',
        confirmPassword: '',
        name: '',
        company: '',
        enterpriseType: '',
        enterpriseTypeInput: '',
        province: '',
        position: '',
        positionInput: ''
      },
      rules: {
        userName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          {
            pattern: userNameRules.pattern,
            message: userNameRules.message,
            trigger: 'blur'
          }
        ],
        password: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          {
            pattern: passwordRules.pattern,
            message: passwordRules.message,
            trigger: 'blur'
          }
        ],
        confirmPassword: [
          { required: true, message: '请再次输入密码', trigger: 'blur' },
          {
            pattern: passwordRules.pattern,
            message: passwordRules.message,
            trigger: 'blur'
          },
          { validator: validConfirmPassword, trigger: 'blur' }
        ],
        name: [
          {
            required: true,
            message: '请输入用户名',
            trigger: 'blur'
          },
          {
            pattern: nameRules.pattern,
            message: nameRules.message,
            trigger: 'blur'
          }
        ],
        email: [
          {
            required: true,
            message: '请输入您的邮箱',
            trigger: 'blur'
          },
          {
            pattern: emailRules.pattern,
            message: emailRules.message,
            trigger: 'blur'
          }
        ],
        company: [
          {
            required: true,
            message: '请输入公司名称',
            trigger: 'blur'
          },
          {
            pattern: companyRules.pattern,
            message: companyRules.message,
            trigger: 'blur'
          }
        ],
        enterpriseType: [
          {
            required: true,
            message: '请选择企业类型',
            trigger: 'change'
          },
          {
            pattern: enterpriseTypeRules.enterpriseType,
            message: enterpriseTypeRules.enterpriseType,
            trigger: 'change'
          }
        ],
        enterpriseTypeInput: [
          {
            required: true,
            message: '请输入企业类型',
            trigger: 'blur'
          },
          {
            pattern: enterpriseTypeInputRules.enterpriseType,
            message: enterpriseTypeInputRules.enterpriseType,
            trigger: 'blur'
          },
          { validator: validEnterpriseTypeInput, trigger: 'blur' }
        ],
        province: [
          {
            required: true,
            message: '请选择省份',
            trigger: 'change'
          }
        ],
        position: [
          {
            required: true,
            message: '请选择岗位',
            trigger: 'change'
          },
          {
            pattern: positionRules.pattern,
            message: positionRules.message,
            trigger: 'change'
          }
        ],
        positionInput: [
          {
            required: true,
            message: '请输入职位',
            trigger: 'blur'
          },
          {
            pattern: positionInputRules.pattern,
            message: positionInputRules.message,
            trigger: 'blur'
          },
          { validator: validPositionInput, trigger: 'blur' }
        ]
      }
    }
  },
  props: {
    register: Function,
    switchPanel: Function
  },
  methods: {
    clearValidMsg(ref) {
      let dom = this.$refs[ref].$el.querySelector('.el-form-item__error')
      if (dom) {
        dom.style.display = 'none'
      }
    },
    inputBlur() {
      setTimeout(() => {
        this.setStyle()
      }, 100)
    },
    setStyle() {
      let domRef1 = this.$refs.enterPriseTypeInputForm
      let dom1 = domRef1 && domRef1.$el.querySelector('.el-form-item__error')

      let domRef2 = this.$refs.positionInputForm
      let dom2 = domRef2 && domRef2.$el.querySelector('.el-form-item__error')
      if (!this.form.enterpriseTypeInput) {
        if (domRef1 && dom1) {
          dom1.style.lineHeight = '32px'
        }
      } else {
        if (domRef1 && dom1) {
          dom1.style.lineHeight = '16px'
        }
      }
      if (!this.form.positionInput) {
        if (domRef2 && dom2) {
          dom2.style.lineHeight = '32px'
        }
      } else {
        if (domRef2 && dom2) {
          dom2.style.lineHeight = '16px'
        }
      }
    },
    registerUser() {
      this.$refs.form.validate((bool, object) => {
        setTimeout(() => {
          this.setStyle()
        }, 100)

        if (bool) {
          let params = {
            userName: this.form.userName,
            password: encryptPassword(this.form.password),
            confirmPassword: encryptPassword(this.form.password),
            name: this.form.name,
            validateNo: this.form.validateNo,
            company: this.form.company,
            email: this.form.email,
            province: this.form.province
          }
          if (this.form.enterpriseType === '其他') {
            params.enterpriseType = this.form.enterpriseTypeInput
          } else {
            params.enterpriseType = this.form.enterpriseType
          }

          if (this.form.position === '其他') {
            params.position = this.form.positionInput
          } else {
            params.position = this.form.position
          }
          this.register(params)
        } else {
          this.$message.error('表单验证失败，请正确填写相关内容后再重新提交')
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.register-info-box {
  position: absolute;
  height: calc(100% - 208px);
  overflow-y: auto;
  top: 96px;
  right: 84px;
  width: 560px;
  border-radius: 5px;
  background-color: var(--login-panel-bg-color);
  box-shadow: var(--login-panel-box-shadow);
  border-radius: 16px;
  border: 1px solid var(--login-panel-border-color);
  padding: 20px 40px 32px 40px;
  text-align: left;
  .login-title {
    margin-bottom: 16px;
    &-wel {
      color: var(--login-panel-title-color);
      font-size: 36px;
    }

    &-tex {
      margin-left: 16px;
      color: var(--login-panel-sub-title-color);
      font-size: 16px;
    }
  }

  .login-register {
    display: flex;
    justify-content: flex-start;
    margin-bottom: 16px;
    &-not {
      color: var(--login-panel-tip-color);
      font-size: 14px;
      font-weight: 400;
    }

    &-addRegiser {
      margin-left: 8px;
      color: var(--base-primary-bgColor);
      font-size: 14px;
      font-weight: 400;
      cursor: pointer;
    }
  }

  .form-box {
    :deep(.el-form-item__label) {
      height: 32px;
    }

    :deep(.el-form-item__content) {
      line-height: 32px;
      .el-select {
        width: 100%;
      }

      .el-form-item__error {
        padding-top: 4px;
      }
      .primary-select,
      .input-primary {
        .el-input__inner {
          background-color: var(--login-panel-input-bgColor);
          border-color: var(--login-panel-input-border-color);
        }
      }
    }

    .form-item-box {
      :deep(.el-form-item) {
        margin-bottom: 24px;
      }
    }
  }

  .common-button-box {
    margin-top: 28px;
    .submit-btn {
      width: 100%;
      height: 40px;
      background-color: var(--base-primary-bgColor);
      font-size: 14px;
      font-weight: 400;

      :deep(span) {
        display: inline-block;
      }
    }
  }
}
</style>
